import React from "react";
import {useEffect} from 'react';
import {Button} from '@material-ui/core';
import {useSelector} from 'react-redux';
import { Grid, TextField,CircularProgress,Typography,Divider} from "@material-ui/core";
import {useHistory} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {checkValidityOfBriefLink,LOAD_BRIEF_PAGE_TEXT} from '../utility';
import { useLocation } from "react-router-dom";

const UiInput = makeStyles({
  root : {
    "& .MuiInputBase-input": {
        borderRadius: '4px',
        border: 'none',
        boxShadow: '0px 1px 6px #7784945e',
        padding: '5px 10px',
        margin: 0
    },
    "& .MuiInputBase-input:focus": {
        boxShadow:'none',
        outline:'none'
    },
    "& .MuiFormLabel-root":{
      textAlign:'center',
    }
  }
});

function LoadBriefForm(props){
    const uiInputClass = UiInput();
    const history = useHistory();
    const [sLoadBrief, setLoadBrief] = React.useState();
    const currentPage = useSelector(state => state.currentPage);
    const location = useLocation();
    const [briefLoadInProgress, setBriefLoadInProgress] = React.useState(false);

    useEffect(()=>{
      if(localStorage.previousURLObject && JSON.parse(localStorage.previousURLObject)[currentPage.postId] && JSON.parse(localStorage.previousURLObject)[currentPage.postId].length > 0){
        briefDispatch();
      }
    },[]);

    const briefDispatch = () => {
      let previousURLObject = (localStorage.previousURLObject && JSON.parse(localStorage.previousURLObject))? JSON.parse(localStorage.previousURLObject) : {};
      // Load the brief if it exists in the localstorage or get the sLoadBrief if new url
      if((sLoadBrief && sLoadBrief.length > 0) || (currentPage.postId && previousURLObject[currentPage.postId])){
        const briefURL = previousURLObject[currentPage.postId]? previousURLObject[currentPage.postId] : sLoadBrief;
        try{
          setBriefLoadInProgress(true);
          const id = new URL(briefURL).pathname.split("/")[2];
          checkValidityOfBriefLink(id).then((valid) => {
            if(!valid){
              setBriefLoadInProgress(false);
              props.openSnackbar(LOAD_BRIEF_PAGE_TEXT.SNACKBAR_TEXT_INVALID);
              return 0;
            }
            previousURLObject[currentPage.postId] = briefURL
            // Add PreviousURL to the localStorage
            localStorage.setItem('previousURLObject', JSON.stringify(previousURLObject));
            history.push({ pathname:`/brief/${id}`, state: {isNotLoggedIn : true}}, {linkView : true});
            window.AP.tanalytics.track('Brief Link Loaded', {brief: briefURL});
          })
        }catch(err){
          setBriefLoadInProgress(false);
          props.openSnackbar("Sorry, Couldn't load Brief.");
        }
      }
    }

    const loadLoginView = () => {
      history.push({
        pathname: '/login_adthrive'
      });
    }

    const loadLoginLegacyView = () => {
      history.push({
        pathname: '/login_legacy'
      });
    }

    const css = `
      .load-brief-form .MuiGrid-root{
        text-align: center;
      }

      .load-brief-form label{
        font-size: 12px !important;
        transition: none !important;
        transform: none !important; 
        height: 20px !important;
        width: auto !important;
        position: relative !important;
        margin-top:8px !important;
        margin-bottom:6px;
      }

      .load-brief-form .MuiInput-formControl{
        margin-top: 0 !important;
      }
    `;

    return(
        <Grid container xs="12" md="12" direction="column" alignItems="center" justify="center" spacing={1} style={{position:'absolute',top:'8rem'}} className="load-brief-form">
          <style>
            {css}
          </style>
          <Grid item>
            <Typography variant="h6" color="primary" style={{fontWeight:'bold',textAlign:'center'}}>{LOAD_BRIEF_PAGE_TEXT.LOAD_BRIEF_HEADING}</Typography>
            <TextField
            className={uiInputClass.root}
            label={LOAD_BRIEF_PAGE_TEXT.BRIEF_TEXTFIELD_LABAL_TEXT}
            placeholder={LOAD_BRIEF_PAGE_TEXT.BRIEF_TEXTFIELD_PLACEMENT_TEXT}
            type="text"
            value={sLoadBrief}
            onChange={(event) => {setLoadBrief(event.target.value)}}
            InputLabelProps={{
                shrink: true,
            }}
            />
          </Grid>
          <Grid item alignItems="center" justify="center" style={{textAlign:'center'}}>
            <Button variant="contained" color="primary" size="small" disabled={briefLoadInProgress} onClick={briefDispatch}>
              {(!briefLoadInProgress) ? LOAD_BRIEF_PAGE_TEXT.LOAD_BRIEF_BUTTON_TEXT : <CircularProgress size={24} />}
            </Button>
          </Grid>
          <Grid item>
            <div style={{"margin":"20px","backgroundColor":"white","padding":"10px","borderRadius":"4px","boxShadow":"0px 1px 6px #7784945e"}}>
              <span style={{fontWeight:'bold'}}>Are you an AdThrive Publisher?</span>
              <p style={{marginTop: '10px', marginBottom: '0'}}>
                Watch <a href="https://vimeo.com/594907722" target="_blank">this short video</a> to learn how to use this plugin with your AdThrive account.
              </p>
            </div>
          </Grid>
          <Grid item style={{textAlign: 'center'}}>
            <Divider style={{marginTop: '10px', marginBottom: '10px'}}/>
            <Grid item xs={12}>
              <a variant="subtitle2" onClick={loadLoginView} style={{textDecoration:'underline',cursor:'pointer'}}>Log In (AdThrive)</a>
            </Grid>
            <Grid item xs={12} style={{marginTop: '6px'}}>
              <a variant="subtitle2" onClick={loadLoginLegacyView} style={{textDecoration:'underline',cursor:'pointer', color: '#7b97b1',display:'none'}}>Log In (legacy)</a>
            </Grid>
          </Grid>
        </Grid>
    );

}

export default LoadBriefForm;